import {FC} from "react";
import {BaseIcon, IPropsIcon} from "./BaseIcon";

interface IProps extends IPropsIcon {

}

export const MinusIcon: FC<IProps> = ({size = 15, fill = 'none'}) => {
    return (
        <BaseIcon size={size} viewBox="0 0 13 4" fill={fill}>
            <path
                d="M11.375 0.527954L0.875 0.527954C0.382813 0.527954 0 0.93811 0 1.40295L0 2.27795C0 2.77014 0.382813 3.15295 0.875 3.15295L11.375 3.15295C11.8398 3.15295 12.25 2.77014 12.25 2.27795V1.40295C12.25 0.93811 11.8398 0.527954 11.375 0.527954Z"
                fill="#0D0D0E"/>
        </BaseIcon>
    )
}